var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartFilled = function SvgChartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F27CE",
    fillRule: "evenodd",
    d: "M1.25.25a.75.75 0 0 0 0 1.5H2v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H17a3 3 0 0 0 3-3V1.75h.75a.75.75 0 1 0 0-1.5zm6.54 15h6.42l.5 1.5H7.29zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.8 12.8 0 0 0-3.558 3.05L10.03 6.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06L9.5 8.06l1.617 1.618a.75.75 0 0 0 1.146-.102 11.3 11.3 0 0 1 3.612-3.321",
    clipRule: "evenodd"
  })));
};
export default SvgChartFilled;